import type { ComponentChildren, CSSProperties } from 'preact'

import {
  modalBackdropMobileStyle,
  modalBackdropStyle,
  modalPanelMobileStyle,
  modalPanelStyle,
} from '../styles'

export function ModalBackdrop({
  isMobile,
  onBackdropClick,
  children,
}: {
  isMobile: boolean
  onBackdropClick: (event: MouseEvent) => void
  children: ComponentChildren
}) {
  return (
    <div
      style={{
        ...modalBackdropStyle,
        ...(isMobile ? modalBackdropMobileStyle : {}),
      }}
      role="dialog"
      aria-modal="true"
      onClick={onBackdropClick}
    >
      {children}
    </div>
  )
}

export function ModalPanel({
  isMobile,
  style,
  children,
  onClick,
}: {
  isMobile: boolean
  style?: CSSProperties
  children: ComponentChildren
  onClick?: (event: MouseEvent) => void
}) {
  return (
    <div
      style={{
        ...modalPanelStyle,
        ...(isMobile ? modalPanelMobileStyle : {}),
        ...style,
      }}
      onClick={onClick}
    >
      {children}
    </div>
  )
}
